import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Edit2, Save, X } from 'lucide-react';
import { toast } from 'sonner';

export default function PlansManagement({ plans, userCounts }) {
  const [editingPlan, setEditingPlan] = useState(null);
  const [planForm, setPlanForm] = useState({});

  const handleEditPlan = (planKey) => {
    setEditingPlan(planKey);
    setPlanForm(plans[planKey]);
  };

  const handleSavePlan = () => {
    toast.info('Plan updates require backend configuration changes');
    setEditingPlan(null);
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-slate-900">Subscription Plans Management</h2>
        <p className="text-slate-500 text-sm mt-1">Edit pricing, features, and limits. Changes apply immediately to the pricing page.</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {Object.entries(plans).map(([key, plan]) => (
          <div key={key} className="bg-white rounded-2xl border-2 border-slate-200 overflow-hidden">
            <div className="bg-gradient-to-r from-violet-500 to-indigo-600 p-6 text-white">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-2xl font-bold">{plan.name}</h3>
                  <p className="text-violet-100 text-sm mt-1">{userCounts?.[key] || 0} active users</p>
                </div>
                {!editingPlan && (
                  <Button
                    size="sm"
                    variant="ghost"
                    onClick={() => handleEditPlan(key)}
                    className="text-white hover:bg-white/20"
                  >
                    <Edit2 className="w-4 h-4" />
                  </Button>
                )}
              </div>
              
              {editingPlan === key ? (
                <div className="space-y-2">
                  <Input
                    value={planForm.price_monthly}
                    onChange={(e) => setPlanForm({ ...planForm, price_monthly: Number(e.target.value) })}
                    className="bg-white/20 border-white/30 text-white placeholder:text-white/70"
                  />
                </div>
              ) : (
                <div className="flex items-baseline gap-2">
                  <span className="text-5xl font-bold">${plan.price_monthly}</span>
                  <span className="text-violet-100">/month</span>
                </div>
              )}
            </div>
            
            <div className="p-6">
              <div className="space-y-3">
                {plan.features.map((feature, idx) => (
                  <div key={idx} className="flex items-start gap-2 text-sm text-slate-700">
                    <span className="text-green-600 mt-0.5">✓</span>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
              
              {editingPlan === key && (
                <div className="mt-4 flex gap-2">
                  <Button onClick={handleSavePlan} size="sm" className="bg-violet-600">
                    <Save className="w-4 h-4 mr-2" />Save
                  </Button>
                  <Button onClick={() => setEditingPlan(null)} size="sm" variant="outline">
                    <X className="w-4 h-4 mr-2" />Cancel
                  </Button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
